// feito por dev: O ESTAGIÁRIO
import type { MediaCategory } from '@/types/commerce'

export const categories: Array<'Todas' | MediaCategory> = [
  'Todas',
  'Paisagens',
  'Cachoeiras',
  'Montanhas',
  'Cidades',
  'Litoral',
  'Natureza',
  'Imagens aéreas',
]

export const formatPrice = (cents: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100)
